module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon17.ca548ce0.png";